import moment from 'moment';
import {all, takeEvery, put, take} from 'redux-saga/effects';
import sharedActions from './actionsShared';
import {loadLocaleCreator} from './sagas/loadLocale';
import getDefaultLocale from './helpers/getDefaultLocale';
import {loadLocale} from './actionCreatorsShared';
import actions from './actions';
import isEmpty from '../../helpers/isEmpty';
import isArray from '@shared/helpers/isArray';

function* doLoadInitialLocale(widgetPath, locale, localeModule) {
  // master app should pass the current locale to widget
  const currentLocale = !isEmpty(locale) ? locale : getDefaultLocale();
  moment.locale(currentLocale);
  if (isArray(localeModule)) {
    yield all(
      localeModule.map(locModule => {
        const appendMessages = true;
        return put(loadLocale(locale, widgetPath, locModule, appendMessages));
      })
    );
    return;
  } else {
    yield put(loadLocale(currentLocale, widgetPath, localeModule));
  }
}

function* watchLoadInitialLocale() {
  const action = yield take(actions.LOAD_INITIAL);
  yield* doLoadInitialLocale(
    action.payload.widgetPath,
    action.payload.locale,
    action.payload.localeModule
  );
}

// eslint-disable-next-line require-yield
function* onSuccess(locale) {
  moment.locale(locale);
}

function* watchLoadLocale() {
  yield takeEvery(sharedActions.LOAD_LOCALE, loadLocaleCreator(onSuccess));
}

function* sagas() {
  yield all([watchLoadLocale(), watchLoadInitialLocale()]);
}

export default sagas;
